import axios from "axios";

const IoTAPI = axios.create();

IoTAPI.defaults.baseURL = "https://iot-api.sangsang.farm/v1";

export default IoTAPI;
